import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-image',
  template: `
    <div
      [formGroup]="group"
      [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
      [style.background-image]="
        field.caminhoImagemBackground
          ? 'url(' + field.caminhoImagemBackground + ')'
          : ''
      "
      *ngIf="field.visible != null ? (!field.visible ? false : true) : true"
    >
      <img
        class="imagePadrao"
        [ngClass]="field.class"
        (click)="field.onClick()"
        [ngStyle]="field.style()"
        [src]="field.src"
      />
    </div>
  `,
  styles: [],
})
export class ImageComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
